<template>
	<v-carousel hide-delimiters height="auto" cycle>
		<v-carousel-item v-for="(image, i) in images" :key="i" eager>
			<v-img
				:src="image"
				:lazy-src="image"
				class="align-center max"
				eager
				aspect-ratio="1.5"
			></v-img>
		</v-carousel-item>
	</v-carousel>
</template>
<script>
export default {
	props: {
		images: {
			type: Array,
			required: true,
		},
	},
};
</script>
<style scoped></style>
